import { useEffect } from 'react';
import { useBookLocationsContext } from '../../../../contexts/BookLocationsContext/BookLocationsContext';
import { useAsyncOperationState } from '../../../../dorian-shared/hooks/useAsyncOperationState';
import { logger } from '../../../../services/loggerService/loggerService';

export function useImportTextLocations(bookId: number) {
  const { bookLocations, fetchBookLocations } = useBookLocationsContext();

  const [
    requestStatus,
    {
      setToError,
      setToLoading,
      setToSuccess,
    },
  ] = useAsyncOperationState();

  // Always refetch on open so #LOCATION matching is not using a catalog
  // loaded earlier (e.g. another tab added a location). One GET replaces
  // the existing list; do not depend on bookLocations or this re-runs forever.
  useEffect(() => {
    let cancelled = false;
    setToLoading();
    fetchBookLocations(bookId)
      .then(() => {
        if (!cancelled) {
          setToSuccess();
        }
      })
      .catch((error) => {
        logger.error('[ImportTextModal] Error in fetching book locations', error);
        if (!cancelled) {
          setToError('Error in fetching book locations');
        }
      });
    return () => {
      cancelled = true;
    };
  }, [bookId, fetchBookLocations, setToError, setToLoading, setToSuccess]);
  return {
    bookLocations,
    requestStatus,
  };
}
